"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var functionSpecificationToFunction_1 = require("./functionSpecificationToFunction");
var inject_1 = require("./inject");
function reifyRFO(rfo) {
    var fn = functionSpecificationToFunction_1.default(rfo.name || '', rfo.params, rfo.body, rfo.type);
    // Upstream can signal that this function needs to become 'injected'
    // in order to function properly using this flag
    if (rfo.injectee) {
        inject_1.default.apply(null, [fn].concat(rfo.params));
    }
    return fn;
}
exports.default = reifyRFO;
//# sourceMappingURL=reifyRFO.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/reflection/reifyRFO.js
// module id = 138
// module chunks = 35783957827783 127651196306611 162898551421021